__turbopack_context__.v({
  "header": "TableOfContents-module-scss-module__iJ_9MW__header",
  "heading": "TableOfContents-module-scss-module__iJ_9MW__heading",
  "tableOfContents": "TableOfContents-module-scss-module__iJ_9MW__tableOfContents",
  "title": "TableOfContents-module-scss-module__iJ_9MW__title",
});
